// extracted by mini-css-extract-plugin
module.exports = {"cardContainer":"card_cardContainer__2XANL","title":"card_title__1GoNu","inActive":"card_inActive__vpC7R"};